import { Button } from '@mantine/core';
import { useUnit } from 'effector-react';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Row, RegistryModel } from 'shared/lib';
import { Empty, EmptyProps } from '../empty';

export type RegistryTableEmptyProps = EmptyProps & {
	withClearFiltersButton?: boolean;
};

export const createRegistryTableEmpty = <
	TRow extends Row,
	TFilters extends Record<string, unknown>,
	TError,
	TAdditionalData = unknown,
>(
	model: RegistryModel<TRow, TFilters, TError, TAdditionalData>,
) => {
	const RegistryTableEmpty = forwardRef<HTMLDivElement, RegistryTableEmptyProps>(
		({ withClearFiltersButton = true, children, ...props }, ref) => {
			const { t } = useTranslation();

			const [empty, rowsEmpty, clear] = useUnit([
				model.$empty,
				model.$rowsEmpty,
				model.clearFilters,
			]);

			return (
				!empty &&
				rowsEmpty && (
					<Empty
						ref={ref}
						{...props}
					>
						{withClearFiltersButton &&
							(children ?? (
								<Button
									data-test-id='registry-table-empty-clear-filters-button'
									variant='outline'
									onClick={clear}
								>
									{t('registry.clear-filters')}
								</Button>
							))}
					</Empty>
				)
			);
		},
	);

	return RegistryTableEmpty;
};
